import { createAction } from 'Lib/reduxUtils';

import { FLUSH, PERSIST, REHYDRATE, REHYDRATED } from './constants';

export const flush = createAction(FLUSH);
export const persist = createAction(PERSIST);
export const rehydrate = createAction(
  REHYDRATE,
  (key: string, data?: any, { version }: { version?: any } = {}) => ({
    key,
    data,
    version,
  })
);
export const rehydrated = createAction(REHYDRATED);
